import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  booking: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'booking' }),
}

export { paths }
